(function($, window, document, undefined) {
	$.fn.quicksearch = function (target, opt) {
		var timeout, cache, rowcache, jq_results, val = '', e = this, options = $.extend({ 
			delay: 100,
			selector: null,
			stripeRows: null,
			loader: null,
			noResults: '',
			matchedResultsCount: 0,
			bind: 'keyup',
			onBefore: function () { 
				return;
			},
			onAfter: function () { 
				return;
			},
			show: function () {
				this.style.display = "";
			},
			hide: function () {
				this.style.display = "none";
			},
			prepareQuery: function (val) {
				return val.toLowerCase().split(' ');
			},
			testQuery: function (query, txt, _row) {
				for (var i = 0; i < query.length; i += 1) {
					if (txt.indexOf(query[i]) === -1) {
						return false;
					}
				}
				return true;
			}
		}, opt);
		
		this.go = function () {
			
			var i = 0,
				numMatchedRows = 0,
				noresults = true, 
				query = options.prepareQuery(val),
				val_empty = (val.replace(' ', '').length === 0);
			for (var i = 0, len = rowcache.length; i < len; i++) {
				if (val_empty || options.testQuery(query, cache[i], rowcache[i])) {
					options.show.apply(rowcache[i]);
					noresults = false;
					numMatchedRows++;
				} else {
					options.hide.apply(rowcache[i]);
				}
			}
			
			if (noresults) {
				this.results(false);
			} else {
				this.results(true);
				this.stripe();
			}
			
			this.matchedResultsCount = numMatchedRows;
			this.loader(false);
			options.onAfter();
			
			return this;
		};
		
		/*
		 * External API so that users can perform search programatically. 
		 * */
		this.search = function (submittedVal) {
			val = submittedVal;
			e.trigger();
		};
		
		/*
		 * External API to get the number of matched results as seen in 
		 * https://github.com/ruiz107/quicksearch/commit/f78dc440b42d95ce9caed1d087174dd4359982d6
		 * */
		this.currentMatchedResults = function() {
			return this.matchedResultsCount;
		};
		
		this.stripe = function () {
			
			if (typeof options.stripeRows === "object" && options.stripeRows !== null)
			{
				var joined = options.stripeRows.join(' ');
				var stripeRows_length = options.stripeRows.length;
				
				jq_results.not(':hidden').each(function (i) {
					$(this).removeClass(joined).addClass(options.stripeRows[i % stripeRows_length]);
				});
			}
			
			return this;
		};
		
		this.strip_html = function (input) {
			var output = input.replace(new RegExp('<[^<]+\>', 'g'), "");
			output = $.trim(output.toLowerCase());
			return output;
		};
		
		this.results = function (bool) {
			if (typeof options.noResults === "string" && options.noResults !== "") {
				if (bool) {
					$(options.noResults).hide();
				} else {
					$(options.noResults).show();
				}
			}
			return this;
		};
		
		this.loader = function (bool) {
			if (typeof options.loader === "string" && options.loader !== "") {
				 (bool) ? $(options.loader).show() : $(options.loader).hide();
			}
			return this;
		};
		
		this.cache = function () {
			
			jq_results = $(target);
			
			if (typeof options.noResults === "string" && options.noResults !== "") {
				jq_results = jq_results.not(options.noResults);
			}
			
			var t = (typeof options.selector === "string") ? jq_results.find(options.selector) : $(target).not(options.noResults);
			cache = t.map(function () {
				return e.strip_html(this.innerHTML);
			});
			
			rowcache = jq_results.map(function () {
				return this;
			});

			/*
			 * Modified fix for sync-ing "val". 
			 * Original fix https://github.com/michaellwest/quicksearch/commit/4ace4008d079298a01f97f885ba8fa956a9703d1
			 * */
			val = val || this.val() || "";
			
			return this.go();
		};
		
		this.trigger = function () {
			this.loader(true);
			options.onBefore();
			
			window.clearTimeout(timeout);
			timeout = window.setTimeout(function () {
				e.go();
			}, options.delay);
			
			return this;
		};
		
		this.cache();
		this.results(true);
		this.stripe();
		this.loader(false);
		
		return this.each(function () {
			
			/*
			 * Changed from .bind to .on.
			 * */
			$(this).on(options.bind, function () {
				
				val = $(this).val();
				e.trigger();
			});
		});
		
	};

}(jQuery, this, document));


$(document).ready(function() {
  $('#searcher').quicksearch('.faqs-accordion-item', {
    'delay': 500,
    'bind': 'keyup keydown',
    'show': function() {
      if ($('#searcher').val() === '' || $('#searcher').val() === ' ') {
        $('#searcher-results').html('');
        $('.faqs-search-box').removeClass('active');
        $('.search-results-box').removeClass('active');
        return;
      }      
      $(this).addClass('show');   
    },
    'onAfter': function() {
      if ($('#searcher').val() === '' || $('#searcher').val() === ' ') {
        $('.noresults-count').removeClass('active');
        $('.noresults-count .text').html('');
        $('#searcher-results').html('');
        $('.show').removeClass('show');
        $('.faqs-search-box').removeClass('active');
        $('.search-results-box').removeClass('active');
        return;
      }

	    $('#searcher-results').html('');
      $('.show').clone().appendTo("#searcher-results");
      
      var searchText = $('#searcher').val();
      var rx = new RegExp('(?![^<&]+[>;])' + searchText, 'gi');
      
      
      
      
      
      var count = $('#searcher-results > .faqs-accordion-item').length; 
      if ($('.show:first').length > 0) {
        $('.noresults-count').removeClass('active');
        $('.noresults-count .text').html('');
        $('.faqs-search-box').addClass('active');
        $('.search-results-box').addClass('active');
      } else {
        $('.noresults-count .text').html(searchText);
        $('.noresults-count').addClass('active');
        $('.faqs-search-box').addClass('active');
        $('.search-results-box').addClass('active');
      }
    },
    'hide': function() {
      $(this).removeClass('show');
    },
    'prepareQuery': function(val) {
      return new RegExp(val, "i");
      console.log('prepareQuery');
    },
    'testQuery': function(query, txt, _row) {
			return query.test(txt);
      console.log('testQuery');
    }
  });

	
  
	var faqs_acc = $('.faqs-accordion');

	
	$('.faqs-accordion-item', faqs_acc).show().addClass('active');
	
	$('.faqs-accordion-item-content', faqs_acc).hide().addClass('active');

	
	var questions = $('.faqs-accordion-item-header', faqs_acc);
	var new_questions = [];
	questions.each(function() {
		var txt = $(this).text().trim();
		if (txt.length < 40) {
			new_questions.push($(this));
		}
	});
	var random_q = Math.floor(Math.random() * new_questions.length);
	var random_question = new_questions[random_q].text().trim();
	$('#searcher').attr('placeholder', random_question);

	
	$('#searcher + .icon').on('click', function(e) {
		var input = $('#searcher');

		if (input.val() != '') return false;

		$('.faqs-categories a[href="#all"]').trigger('click');
		$('.faqs-accordion-item', faqs_acc).show().addClass('active');
		$('.faqs-search-box').removeClass('active');
		$('.search-results-box').removeClass('active');
		$('#searcher-results').html('');

		var a_header = new_questions[random_q];

		a_header.parent()
			.siblings()
			.find('.faqs-accordion-item-header')
			.removeClass('active')
			.next().hide();

		setTimeout(function() {
			var pos = $('.faqs-accordion-item-header', faqs_acc).eq(random_q).offset().top - ($('#site-header').height() + 30);

			$('body, html').animate({
				scrollTop: pos
			}, 300);

			a_header.trigger('click');
		}, 10);
	});

	
	$('.faqs-categories a').on('click', function(e) {
		$('.faqs-categories a').removeClass('active');
		$(this).addClass('active');

		var id = $(this).attr('href').replace('#', '');
		if (id != 'all') {
			
			$('.faqs-accordion-item', faqs_acc).removeClass('active').addClass('hide');
			$('.faqs-accordion-item[data-category="'+id+'"]', faqs_acc).addClass('active').removeClass('hide');
		} else {
			
			$('.faqs-accordion-item', faqs_acc).removeClass('hide').addClass('active');
		}

    e.stopPropagation();
	});

	
	faqs_acc.on('click', '.faqs-accordion-item-header', function(e) {
		$(this).toggleClass('active');

		$(this).hasClass('active')
			? $(this).next().slideDown()
			: $(this).next().slideUp();
		
		$(this).parent()
			.siblings()
			.find('.faqs-accordion-item-header')
			.removeClass('active')
			.next().slideUp();

    e.stopPropagation();
	});
	
	
  $('.faqs-content, #searcher-results').on('click', 'a[href*="#"]', function(e) {
		$('.faqs-categories a[href="#all"]').trigger('click');
		$('.faqs-accordion-item', faqs_acc).show().addClass('active');
		$('.faqs-search-box').removeClass('active');
		$('.search-results-box').removeClass('active');
		$('#searcher-results').html('');

    var id = $(this).attr('href');
    if (id.indexOf('.') >= 0) {
      id = id.replace('.', '\\.');
    }
		var target = $('.faqs-accordion .faqs-accordion-item-header[href="'+id+'"]');
    var pos = id == '#top' ? 0 : target.offset().top - ($('#site-header').height() + 30);
    
    $('body, html').animate({
      scrollTop: pos
    }, 300);

		target.trigger('click');
    
    e.stopPropagation();
  });

	
	var hash = window.location.hash;
	var a_category = $('.faqs-categories a[href="'+hash+'"]');
	var a_header = $('.faqs-accordion .faqs-accordion-item-header[href="'+hash+'"]');
	if (a_category.length > 0) {
		a_category.trigger('click');
	} else if (a_header.length > 0) {
    var pos = a_header.offset().top - ($('#site-header').height() + 30);
    
    $('body, html').animate({
      scrollTop: pos
    }, 300);

		a_header.trigger('click');
	}
});